import styled from "@emotion/styled";
import Text from "@components/Text/index.js";
import {pxToRem} from "@services/theme/utils";
import {getIconByResourceType} from "@services/icons/index.js";
import OverviewButton from "@components/OverviewButton";
import { getResponsiveCSS } from '@utils/cssHelpers';
import { FiFlag } from 'react-icons/fi';

export const ListItem = styled('div', {
    shouldForwardProp: props => props !== 'isFirstElement',
})<{ isFirstElement?: boolean }>(({isFirstElement, theme}) => ({
    display: 'grid',
    alignItems: 'center',
    minHeight: 54,
    gridTemplate: `'${(!isFirstElement) ? 'status completion' : ''} icon name actions flag'`,
    gridTemplateColumns: `${(!isFirstElement) ? `${pxToRem(26)} ${pxToRem(26)}` : ''} ${pxToRem(26)} minmax(0, 1fr) max-content ${pxToRem(32)}`,
    paddingLeft: !isFirstElement ? pxToRem(20) : 0,
    paddingRight: pxToRem(20),
    borderBottom: `1px solid ${theme.palette.novotalk.$resourcesTableBorderColor}`,
    '&:last-child': {
        border: 'none',
    },
    '&:hover': {
        backgroundColor: !isFirstElement ? theme.palette.novotalk.$resourcesTableBgColorHover : '',
    },
    '&:hover .courseLocationFlag, &:focus-within .courseLocationFlag': {
        opacity: 1,
    },
}))

export const NameContainer = styled('div')({
    gridArea: 'name',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: pxToRem(20),
});

export const NameText = styled(Text, {
    shouldForwardProp: props => props !== 'isExpandable' && props !== 'isCurrentLevel'
})<{ isExpandable?: boolean, isCurrentLevel?: boolean }>({
        whiteSpace: 'nowrap',
    fontSize: pxToRem(14),
    },
    ({isExpandable, isCurrentLevel, theme}) => ({
        color: isCurrentLevel ?  theme.palette.novotalk.$novotalkBlue : theme.palette.novotalk.$textColorDarkBlue,
        cursor: isExpandable ? 'pointer' : 'auto',
    })
);

export const IconWrapper = styled('div')({
    gridArea: 'status',
    display: 'flex',
    alignItems: 'center',
    marginTop: pxToRem(1),
    height: 21,
    width: pxToRem(26),
});

export const CompletionIconWrapper = styled(IconWrapper, {
    shouldForwardProp: props => props !== 'isAvailable',
})<{ isAvailable?: boolean }>(({isAvailable, theme}) => ({
    gridArea: 'completion',
    '& > *': {
        color: !isAvailable ? theme.palette.novotalk.$textColorLightGray : undefined,
    },
}));

export const getStyledIconByType = (type: string) => styled(getIconByResourceType(type), {
    shouldForwardProp: props => props !== 'isCurrentLevel',
})<{ isCurrentLevel?: boolean }>(({theme, isCurrentLevel}) => ({
        gridArea: 'icon',
        fontSize: pxToRem(19),
        marginTop: 0,
        width: 26,
        paddingRight: pxToRem(7),
        color: isCurrentLevel ? theme.palette.novotalk.$novotalkBlue : theme.palette.novotalk.$textColorLightGray,
        cursor: 'auto',
    })
);

export const MoveBtn = styled(OverviewButton,{
    shouldForwardProp: props => props !== 'hideButton'
})<{hideButton?:boolean}>(({hideButton})=>({
    gridArea: 'actions',
    height: 32,
    visibility: hideButton ? 'hidden' : 'visible',
    pointerEvents: hideButton ? 'none' : 'auto',
    
}),
{...getResponsiveCSS('marginLeft', 6, 8, '&:last-of-type')}
)

export const FlagIcon = styled(FiFlag)({
    width: 18,
    height: 18,
});

export const FlagButton = styled('button', {
    shouldForwardProp: props => props !== 'isFlagged',
})<{ isFlagged?: boolean }>(({isFlagged, theme}) => ({
    gridArea: 'flag',
    width: 32,
    height: 32,
    padding: 7,
    border: 0,
    background: 'transparent',
    color: isFlagged ? theme.palette.error.main : theme.palette.novotalk.$textColorLightGray,
    opacity: isFlagged ? 1 : 0,
    transition: 'opacity 120ms ease, color 120ms ease',
    cursor: 'pointer',
    '&:focus-visible': {
        opacity: 1,
        outline: `2px solid ${theme.palette.novotalk.$novotalkBlue}`,
        outlineOffset: 1,
    },
}));
